import { render, staticRenderFns } from "./reviewDialog.vue?vue&type=template&id=2828c89b&scoped=true"
import script from "./reviewDialog.vue?vue&type=script&lang=js"
export * from "./reviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828c89b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2828c89b')) {
      api.createRecord('2828c89b', component.options)
    } else {
      api.reload('2828c89b', component.options)
    }
    module.hot.accept("./reviewDialog.vue?vue&type=template&id=2828c89b&scoped=true", function () {
      api.rerender('2828c89b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/accountsPayableReview/cmp/reviewDialog.vue"
export default component.exports